module.exports = __webpack_public_path__ + "img/restore-icon-danger.9da17115.svg";